import React from 'react';
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg';

function CompanyKitchenOneLineLogo(props) {
  return (
    <Svg
      width={280}
      height={26}
      viewBox="0 0 280 26"
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0_4561_30456)">
        <Path
          d="M142.374 17.6881C141.245 18.744 139.354 19.5437 137.17 19.5437C133.531 19.5437 130.802 16.5972 130.802 12.9561C130.802 9.3149 133.531 6.37027 137.17 6.37027C139.354 6.37027 141.173 7.17 142.374 8.29773V1.20334C140.808 0.547338 139.026 0.184326 137.17 0.184326C129.929 0.184326 124.434 5.71611 124.434 12.9561C124.434 20.196 129.927 25.7278 137.17 25.7278C139.026 25.7278 140.81 25.3648 142.374 24.7088V17.6863V17.6881Z"
          fill="#6AAA37"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.439 17.2569L146.473 17.22L146.533 17.2937L153.652 25.9931H162.43L154.35 16.1199L151.807 13.0131L151.746 12.9394L154.26 9.87134L162.338 0H153.56L146.439 8.69754L142.937 12.9781L146.439 17.2569Z"
          fill="#3A96DB"
        />
        <Path
          d="M6.33704 7.66379C3.1418 7.71723 1.47416 10.238 1.47416 12.7939C1.47416 15.3497 3.17866 17.8336 6.33704 17.8336C7.79278 17.8336 9.24851 17.1592 10.1883 16.0407L11.2184 16.8939C10.0482 18.2962 8.29031 19.1825 6.33889 19.1825C2.20203 19.1825 0 16.0241 0 12.7939C0 9.56362 2.20203 6.31494 6.33704 6.31494C8.11156 6.31494 9.69076 7.02622 10.8443 8.19633L9.90451 9.17296C8.98132 8.21476 7.6859 7.62878 6.33704 7.66379Z M22.8974 19.2175C19.4018 19.2175 16.5603 16.2895 16.5603 12.7754C16.5603 9.26141 19.4018 6.29651 22.8974 6.29651C26.393 6.29651 29.2326 9.27615 29.2326 12.7754C29.2326 16.2747 26.393 19.2175 22.8974 19.2175Z M22.8808 7.64537C20.4484 7.66379 18.0345 9.47332 18.0345 12.7754C18.0345 16.0776 20.4669 17.8687 22.8974 17.8687C25.3279 17.8687 27.7603 16.1292 27.7603 12.7754C27.7603 9.42173 25.3113 7.62878 22.8808 7.64537Z M46.202 18.9688V9.17112L42.5461 17.2808H41.2875L37.5597 9.08083V18.9669H36.139V6.47525H38.002L41.9067 15.3847L45.7929 6.47525H47.6762V18.9688H46.202Z M58.9664 14.4265H56.6777V18.9706H55.222V6.49368H58.9498C61.736 6.49368 63.1383 8.51696 63.1383 10.5052C63.1383 12.4935 61.736 14.4265 58.9664 14.4265Z M58.9498 7.84253H56.6777V13.0776H58.9498C60.7778 13.0776 61.6825 11.7472 61.6825 10.5052C61.6825 9.26325 60.7593 7.84253 58.9498 7.84253Z M76.9474 18.9688L75.5101 14.9941H70.6988L69.2966 18.9688H67.7358L72.1914 6.45682H73.9844L78.4935 18.9688H76.9493H76.9474Z M73.0962 8.00101L71.1448 13.6434H75.031L73.0962 8.00101Z M92.5146 18.9688L86.1425 8.56856V18.9688H84.6868V6.54712H86.4447L93.119 17.373V6.54712H94.5747V18.9706H92.5146V18.9688Z M106.432 14.0174V18.9688H104.995V14.0174C103.628 11.6035 102.119 8.85233 100.753 6.45682H102.423L105.725 12.4732C106.807 10.485 107.943 8.44325 109.007 6.45682H110.693L106.434 14.0174H106.432Z"
          fill="#111111"
        />
        <Path
          d="M183.518 19.2967H181.797L177.36 13.3522L176.011 14.6992V19.2967H174.539V6.78479H176.011V12.9615L181.709 6.78479H183.325L178.336 12.394L183.518 19.2967Z"
          fill="#111111"
        />
        <Path
          d="M194.305 19.2967V6.81982H195.761V19.2967H194.305Z"
          fill="#111111"
        />
        <Path
          d="M210.733 8.25898V19.2967H209.261V8.25898H206.172V6.83826H213.821V8.25898H210.733Z"
          fill="#111111"
        />
        <Path
          d="M226.729 7.99181C223.534 8.04525 221.866 10.5661 221.866 13.1219C221.866 15.6777 223.571 18.1617 226.729 18.1617C228.185 18.1617 229.641 17.4872 230.58 16.3687L231.609 17.2219C230.438 18.6242 228.681 19.5105 226.727 19.5105C222.592 19.5105 220.392 16.3521 220.392 13.12C220.392 9.88795 222.592 6.64111 226.727 6.64111C228.502 6.64111 230.081 7.3524 231.236 8.52251L230.295 9.49914C229.372 8.54094 228.076 7.95496 226.727 7.98997L226.729 7.99181Z"
          fill="#111111"
        />
        <Path
          d="M245.897 19.2967V13.7594H240.199V19.2967H238.725V6.81982H240.199V12.4474H245.897V6.81982H247.369V19.2967H245.897Z"
          fill="#111111"
        />
        <Path
          d="M262.38 19.2801H255.724V6.80322H262.38V8.17051H257.198V12.3755H262.31V13.7428H257.198L257.18 17.8944H262.38V19.2801Z"
          fill="#111111"
        />
        <Path
          d="M277.942 19.2968L271.57 8.89657V19.2968H270.116V6.87329H271.872L278.544 17.6991V6.87329H280V19.2968H277.942Z"
          fill="#111111"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_4561_30456">
          <Rect width={280} height={25.9931} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default CompanyKitchenOneLineLogo;
